import { render, staticRenderFns } from "./CardInformations.vue?vue&type=template&id=0c587556"
import script from "./CardInformations.vue?vue&type=script&lang=js"
export * from "./CardInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports